import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 border-t border-gray-800">
      <div className="container mx-auto text-center px-4">
        <p className="text-gray-400 text-sm mb-4">
          Mahesh Bodhanam — Full-Stack &amp; Mobile App Developer
        </p>
        <div className="mb-4 flex justify-center gap-6 text-xl">
          <a
            href="https://github.com/maheshbodhanam"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-cyan-400 transition-colors duration-200"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/mahesh-bodhanam-3a4793188/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-cyan-400 transition-colors duration-200"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="mailto:bodhanammahesh44@gmail.com"
            className="hover:text-cyan-400 transition-colors duration-200"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
        </div>
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Mahesh Bodhanam. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
